import { useState, useEffect, useRef } from "react";

const useFetchRoomData = (floor) => {
    const [rooms, setRooms]   = useState([]);
    const [loading, setLoading] = useState(true);
    const wsRef = useRef(null);

    useEffect(() => {
        setLoading(true);
        setRooms([]);

        let ws = null;
        let reconnectTimer = null;
        let unmounted = false;

        const connect = () => {
            if (unmounted) return;

            const wsBase = process.env.REACT_APP_API_URL.replace(/^http/, 'ws');
            ws = new WebSocket(`${wsBase}/ws/room?floor=${floor}`);
            wsRef.current = ws;

            ws.onmessage = (event) => {
                try {
                    setRooms(JSON.parse(event.data));
                } catch (e) {
                    console.error("WebSocket parse error:", e);
                } finally {
                    setLoading(false);
                }
            };

            ws.onerror = () => {
                setLoading(false);
            };

            ws.onclose = () => {
                if (!unmounted) {
                    // 3 秒後自動重連
                    reconnectTimer = setTimeout(connect, 3000);
                }
            };
        };

        connect();

        return () => {
            unmounted = true;
            clearTimeout(reconnectTimer);
            if (ws) ws.close();
        };
    }, [floor]);

    return { rooms, loading };
};

export default useFetchRoomData;
